import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import LoadingSwitchTransition from '@/components/LoadingSwitchTransition';
import PlaceholderLoading from '@/components/PlaceholderLoading';
import ProtocoloExecutadoDetail from '@/features/execucao/components/ProtocoloExecutadoDetail/index.b2b';
import { useExecucaoContext } from '@/features/execucao/providers/ExecucaoProvider';
import ExecucaoService from '@/features/execucao/services/ExecucaoAPI';

import EnterpriseHeaderProtocoloExecutado from '../../components/EnterpriseHeaderProtocoloExecutado';
import { useEnterpriseContext } from '../../contexts/EnterpriseContext';
import EnterprisePageLayout from '../../layouts/EnterprisePageLayout';

const PlaceholderContent = () => (
  <PlaceholderLoading.Rect
    height={513}
    width="100%"
    style={{
      display: 'flex',
      borderRadius: 16,
    }}
  />
);

const VisualizacaoProtocoloEnterprise: React.FC = () => {
  const history = useHistory();
  const protocoloId = useParams<{ id: string }>().id;
  const [isLoadingProtocolo, setIsLoadingProtocolo] = useState(true);
  const [
    { protocoloExecutado },
    { dispatchSetExecucaoResumo },
  ] = useExecucaoContext();
  const [, { dispatchStartFromExecution }] = useEnterpriseContext();

  React.useEffect(() => {
    if (protocoloExecutado) {
      setIsLoadingProtocolo(false);
    }
  }, [protocoloExecutado]);

  React.useEffect(() => {
    if (!isLoadingProtocolo && !protocoloExecutado) {
      history.replace('/');
    }
  }, [history, isLoadingProtocolo, protocoloExecutado]);

  React.useEffect(() => {
    async function loadProtocolo() {
      try {
        const execucao = await ExecucaoService.getExecucaoResumo(protocoloId);
        dispatchSetExecucaoResumo(execucao);
        dispatchStartFromExecution(execucao);
      } catch {
        history.replace('/unauthorized');
      }
    }

    loadProtocolo();
    // eslint-disable-next-line
  }, []);

  return (
    <EnterprisePageLayout Nav={<EnterpriseHeaderProtocoloExecutado />}>
      <LoadingSwitchTransition
        loading={isLoadingProtocolo}
        LoadingComponent={<PlaceholderContent />}
        style={{
          flex: 1,
        }}
      >
        <ProtocoloExecutadoDetail />
      </LoadingSwitchTransition>
    </EnterprisePageLayout>
  );
};

export default VisualizacaoProtocoloEnterprise;
